import React, { Component } from 'react'
import {
    Card,
    Row,
    Col,
    Button,
    Modal,
    Dropdown,
    Menu,
    Empty,
    message
} from 'antd'
import {
    VerticalAlignTopOutlined,
    PlusOutlined,
    DeleteOutlined,
    EllipsisOutlined
} from '@ant-design/icons'
import styled from 'styled-components'
import cloneDeep from 'lodash/cloneDeep'
import {
    getMainMenuList,
    setMainMenuList,
    getCategoryMenuList,
    setCategoryMenuList,
    getAllCategories,
    getAllProductCategories
} from '../../../services/apiServices'
import { generateMenuListAuto } from '../../../services/appServices'
import DragBoard from './DragBoard/DragBoard'
import MenuSettingModal from '../../../commons/Modal/MenuSettingModal/MenuSettingModal'
import LinkReviseModal from '../../../commons/Modal/MenuSettingModal/LinkReviseModal'
import SaveButton from './../../../commons/Button/SaveButton'
import LoadingModal from '../../../commons/Modal/Loading'

const Container = styled(Card)``

class HeaderMainMenu extends Component {
    state = {
        isLoading: false,
        isOpenEditor: false,
        isOpenLinkReviseModal: false,
        selectedMenu: {},
        selectedMenuIndexList: [],
        menuList: []
    }

    componentDidMount() {
        this.getMenuList()
    }

    async getMenuList() {
        let { type } = this.props
        this.setState({ isLoading: true })
        try {
            let menuList =
                type == 'MAIN'
                    ? await getMainMenuList()
                    : await getCategoryMenuList()
            this.setState({
                isLoading: false,
                menuList
            })
        } catch (error) {
            this.setState({ isLoading: false })
            message.error(this.props.T('SOMETHING_WRONG'))
        }
    }

    async setMenuList(data) {
        let { type } = this.props
        let params = { body: { menu: data } }
        this.setState({ isLoading: true })
        try {
            if (type == 'MAIN') {
                await setMainMenuList(params)
            } else {
                await setCategoryMenuList(params)
            }
            this.setState({
                isLoading: false
            })
            message.success(this.props.T('SAVED'))
        } catch (error) {
            this.setState({ isLoading: false })
            message.error(this.props.T('SOMETHING_WRONG'))
        }
    }

    onSave() {
        this.setMenuList(this.state.menuList)
    }

    onToggleEditor(status) {
        let state = {
            isOpenEditor: status
        }
        if (!status) {
            state = {
                ...state,
                selectedType: 0,
                selectedMenu: {},
                selectedMenuIndexList: []
            }
        }
        this.setState(state)
    }

    onEditMenu(indexList, menu) {
        this.setState(
            {
                selectedMenuIndexList: indexList,
                selectedMenu: menu
            },
            () => this.onToggleEditor(true)
        )
    }

    onToggleLinkReviseModal(status) {
        let state = {
            isOpenLinkReviseModal: status
        }
        this.setState(state)
    }

    onSubmitReviseMenu(menuList = []) {
        this.setState({ menuList, isOpenLinkReviseModal: false })
    }

    onAddSubmenu(indexList) {
        this.setState(
            {
                selectedMenuIndexList: indexList,
                selectedMenu: {}
            },
            () => this.onToggleEditor(true)
        )
    }

    onRemoveMenu(indexList) {
        console.log(indexList)
        showRemoveConfirm(this.props.T.bind(this), () => {
            let menuList = cloneDeep(this.state.menuList)
            let indexLength = indexList.length

            if (indexLength == 1) {
                menuList.splice(indexList[0], 1)
            } else if (indexLength == 2) {
                menuList[indexList[0]].submenus.splice(indexList[1], 1)
            } else if (indexLength == 3) {
                menuList[indexList[0]].submenus[indexList[1]].submenus.splice(
                    indexList[2],
                    1
                )
            }

            this.setState({ menuList })
        })
    }

    onFinishSaveMenu() {
        this.onToggleEditor(false)
        this.getMenuList()
    }

    onSubmitMenu(values) {
        let data = {
            background_url: values.submenuBackgroundImage,
            icon: values.icon,
            is_new_tab: values.isNewTab,
            submenu_style: values.submenuStyle,
            tag_color: values.tagColor,
            tag_effect: values.tagAnimation,
            tag_title: values.tagTitle,
            title: values.title,
            url: values.url
        }

        let menuList = cloneDeep(this.state.menuList)

        if (values.type == 'EDIT') {
            let indexList = this.state.selectedMenuIndexList
            let indexLength = indexList.length

            let updateData = { ...data }

            if (indexLength == 1) {
                menuList[indexList[0]] = {
                    ...menuList[indexList[0]],
                    ...updateData
                }
            } else if (indexLength == 2) {
                menuList[indexList[0]].submenus[indexList[1]] = {
                    ...menuList[indexList[0]].submenus[indexList[1]],
                    ...updateData
                }
            } else if (indexLength == 3) {
                menuList[indexList[0]].submenus[indexList[1]].submenus[
                    indexList[2]
                ] = {
                    ...menuList[indexList[0]].submenus[indexList[1]].submenus[
                        indexList[2]
                    ],
                    ...updateData
                }
            }
        } else if (values.type == 'ADD') {
            let indexList = values.parentMenu.split(',')
            let indexLength = indexList.length

            let addData = { ...data, id: new Date().valueOf() }

            if (values.parentMenu == '-1') {
                menuList.push(addData)
            } else if (indexLength == 1) {
                menuList[indexList[0]].submenus.push(addData)
            } else if (indexLength == 2) {
                menuList[indexList[0]].submenus[indexList[1]].submenus.push(
                    addData
                )
            }
        }
        this.setState({ menuList }, () => {
            if (values.type == 'ADD' && values.parentMenu == '-1') {
                setTimeout(() => {
                    let layoutContent =
                        document.querySelector('.layount-content')
                    if (layoutContent) {
                        layoutContent.scrollTo(0, layoutContent.scrollHeight)
                    }
                }, 100)
            }
        })
        this.onToggleEditor(false)
    }

    setBlocks(blocks) {
        this.setState({
            menuList: blocks
        })
    }

    async getCategoryList(type, onSuccess) {
        this.setState({ isLoading: true })
        try {
            let params = { body: { include_url: true } }
            let categories =
                type == 'POST'
                    ? await getAllCategories(params)
                    : await getAllProductCategories(params)
            this.setState({
                isLoading: false
            })
            onSuccess && onSuccess(categories)
        } catch (error) {
            this.setState({ isLoading: false })
            message.error(this.props.T('SOMETHING_WRONG'))
        }
    }

    onSelectExtensionMenu(type) {
        switch (type) {
            case 'CREATE_POST_CAT_URL':
                this.onSelectAutoGenerateMenuList('POST')
                break
            case 'CREATE_PRODUCT_CAT_URL':
                this.onSelectAutoGenerateMenuList('PRODUCT')
                break
            case 'REVISE_URL':
                this.onToggleLinkReviseModal(true)
                break
            default:
                break
        }
    }

    onSelectAutoGenerateMenuList(type) {
        this.onShowReplaceMenuListConfirm(() => {
            this.getCategoryList(type, menuList => {
                let newMenuList = generateMenuListAuto(menuList)
                this.setState({ menuList: newMenuList })
                console.log('newMenuList', newMenuList)
            })
        })
    }

    onShowReplaceMenuListConfirm(callback) {
        if (this.state.menuList.length > 0) {
            showReplaceMenuListConfirm(this.props.T.bind(this), () => {
                callback && callback()
            })
        } else {
            callback && callback()
        }
    }

    onRemoveAll() {
        showRemoveAllConfirm(this.props.T.bind(this), () => {
            this.setState({ menuList: [] })
        })
    }

    render() {
        let { T, type } = this.props
        return (
            <Container
                title={
                    <span className="text-xl">
                        <VerticalAlignTopOutlined /> {T('HEADER')} -{' '}
                        {type == 'MAIN' ? T('MAIN_MENU') : T('CATEGORIES_MENU')}
                    </span>
                }
                extra={
                    <>
                        <Button
                            type="primary"
                            icon={<PlusOutlined />}
                            style={{ marginRight: 10 }}
                            onClick={() => this.onToggleEditor(true)}>
                            {T('ADD_MENU')}
                        </Button>
                        {this.state.menuList.length > 0 && (
                            <Button
                                type="danger"
                                icon={<DeleteOutlined />}
                                style={{ marginRight: 10 }}
                                onClick={() => this.onRemoveAll()}>
                                {T('REMOVE_ALL')}
                            </Button>
                        )}
                        <Dropdown
                            overlay={linkGenerateMenu(
                                T,
                                this.onSelectExtensionMenu.bind(this)
                            )}
                            placement="bottomCenter">
                            <Button>
                                <EllipsisOutlined />
                            </Button>
                        </Dropdown>
                    </>
                }>
                {!this.state.isLoading && this.state.menuList.length == 0 ? (
                    <Empty />
                ) : (
                    <Row type="flex" justify="center">
                        <Col
                            xs={24}
                            md={24}
                            lg={16}
                            className="layount-content">
                            <DragBoard
                                T={T}
                                menuList={this.state.menuList}
                                setBlocks={this.setBlocks.bind(this)}
                                setState={this.setState.bind(this)}
                                onEditMenu={this.onEditMenu.bind(this)}
                                onRemoveMenu={this.onRemoveMenu.bind(this)}
                                onAddSubmenu={this.onAddSubmenu.bind(this)}
                            />
                        </Col>
                    </Row>
                )}

                <MenuSettingModal
                    T={T}
                    isOpen={this.state.isOpenEditor}
                    menu={this.state.selectedMenu}
                    menuList={this.state.menuList}
                    selectedMenuIndexList={this.state.selectedMenuIndexList}
                    onClose={() => this.onToggleEditor(false)}
                    onSubmit={this.onSubmitMenu.bind(this)}
                />

                <LinkReviseModal
                    T={T}
                    isOpen={this.state.isOpenLinkReviseModal}
                    menuList={this.state.menuList}
                    onSubmit={this.onSubmitReviseMenu.bind(this)}
                    onClose={() => this.onToggleLinkReviseModal(false)}
                />

                <LoadingModal isOpen={this.state.isLoading} />

                <SaveButton T={T} onSubmit={() => this.onSave()} />
            </Container>
        )
    }
}

const linkGenerateMenu = (T, onClick) => (
    <Menu>
        <Menu.Item key="1" onClick={() => onClick('CREATE_POST_CAT_URL')}>
            {T('CREATE_MENU_FROM_ALL_ARTICLE_CATEGORIES')}
        </Menu.Item>
        <Menu.Item key="2" onClick={() => onClick('CREATE_PRODUCT_CAT_URL')}>
            {T('CREATE_MENU_FROM_ALL_PRODUCT_CATEGORIES')}
        </Menu.Item>
        <Menu.Item key="3" onClick={() => onClick('REVISE_URL')}>
            {T('REPLACE_URL')}
        </Menu.Item>
    </Menu>
)

const showRemoveConfirm = (T, onOk) => {
    Modal.confirm({
        title: T('CONFIRM_REMOVE_MENU_MSG'),
        okType: 'danger',
        okText: T('CONFIRM'),
        cancelText: T('CANCEL'),
        maskClosable: true,
        centered: true,
        onOk() {
            onOk()
        },
        onCancel() {
            console.log('Cancel')
        }
    })
}

const showReplaceMenuListConfirm = (T, onOk) => {
    Modal.confirm({
        title: T('CONFIRM_REPLACE_MENU_MSG'),
        content: T('REPLACE_MENU_DETAIL_MSG'),
        okType: 'danger',
        okText: T('CONFIRM'),
        cancelText: T('CANCEL'),
        maskClosable: true,
        centered: true,
        onOk() {
            onOk()
        },
        onCancel() {
            console.log('Cancel')
        }
    })
}

const showRemoveAllConfirm = (T, onOk) => {
    Modal.confirm({
        title: T('CONFIRM_REMOVE_ALL_MENU_MSG'),
        okType: 'danger',
        okText: T('CONFIRM'),
        cancelText: T('CANCEL'),
        maskClosable: true,
        centered: true,
        onOk() {
            onOk()
        },
        onCancel() {
            console.log('Cancel')
        }
    })
}

export default HeaderMainMenu
